import billingApiModule from '../billingApi.module';

class BillingPreviewApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getUpcomingCharges() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/billing-preview`
        );
    }
}

export default billingApiModule.service(
    'billingPreviewApiService',
    BillingPreviewApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/preview/billingPreviewApi.service.js